module.exports = __webpack_public_path__ + "static/img/mountain_background.72d8089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/mountain_background.png
// module id = YCaI
// module chunks = 0